module.exports = __webpack_public_path__ + "img/FB.7aad9e81.svg";